import React, { useEffect, useState } from 'react';
import './AuditReports.scss';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import PageBanner from "../../components/PageBanner";
import { getAuditReports } from '../../services/data.service';
import { mediaUrl } from '../../services/assetUrl';
import {
  FaFilePdf, FaChartPie, FaBuilding, FaMicroscope, FaArrowRight,
  FaGraduationCap, FaShieldAlt, FaCoins,
} from 'react-icons/fa';

// Map stored icon key strings to react-icons components.
const ICONS = {
  chart: FaChartPie,
  building: FaBuilding,
  microscope: FaMicroscope,
  graduation: FaGraduationCap,
  shield: FaShieldAlt,
  coins: FaCoins,
};
const FeatureIcon = ({ name }) => {
  const Cmp = ICONS[name] || FaChartPie;
  return <Cmp />;
};

const AuditReports = () => {
  const [model, setModel] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getAuditReports();
        if (active) setModel(res?.data || null);
      } catch (e) {
        if (active) setModel(null);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  if (loading) {
    return (
      <>
        <Header />
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <p style={{ color: '#53545b', fontSize: '1.1rem' }}>Loading…</p>
        </div>
        <Footer />
      </>
    );
  }

  if (!model) {
    return (
      <>
        <Header />
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '8px' }}>
          <h2 style={{ color: '#0e2455' }}>Audit Reports unavailable</h2>
          <p style={{ color: '#53545b' }}>Please try again later.</p>
        </div>
        <Footer />
      </>
    );
  }

  const hero = model.hero || {};
  const budget = model.budgetSection || {};
  const timeline = model.timeline || {};
  const reports = timeline.reports || [];

  return (
    <>
      <Header />

      <PageBanner
        title={hero.title || "Audit Reports"}
        eyebrow={hero.eyebrow || "Financial Transparency"}
        subtitle={hero.subtitle}
        image={hero.bannerImage ? mediaUrl(hero.bannerImage) : undefined}
      />

      <div className="audit-reports-container">

        {/* Institutional Budget Details Section */}
        <section className="budget-redesign-section">
          <div className="budget-redesign-container">
            <div className="budget-redesign-image-area">
              <div className="budget-redesign-image-glow"></div>
              <img
                src={mediaUrl(budget.image)}
                alt={budget.title || "Institutional Budget"}
                className="budget-redesign-img"
              />
            </div>

            <div className="budget-redesign-content-area">
              {budget.badge && <div className="budget-redesign-badge">{budget.badge}</div>}
              <h2 className="budget-redesign-title">{budget.title}</h2>
              <p className="budget-redesign-intro">{budget.intro}</p>

              <ul className="budget-redesign-features">
                {(budget.features || []).map((f, i) => (
                  <li className="budget-feature-item" key={i}>
                    <div className="budget-feature-icon"><FeatureIcon name={f.icon} /></div>
                    <div className="budget-feature-text">
                      <strong>{f.strong}</strong>
                      <span>{f.span}</span>
                    </div>
                  </li>
                ))}
              </ul>

              {budget.buttonLink && (
                <a href={mediaUrl(budget.buttonLink)} target="_blank" rel="noopener noreferrer" className="budget-redesign-btn">
                  <span>{budget.buttonLabel || "View Full Budget Report"}</span>
                  <div className="budget-redesign-btn-icon"><FaArrowRight /></div>
                </a>
              )}
            </div>
          </div>
        </section>

        {/* Institutional Audit Reports Timeline */}
        <div className="audit-timeline-section">
          <div className="audit-timeline-header">
            <div className="audit-timeline-header__indicator"></div>
            <h2 className="audit-timeline-header__title">
              {timeline.heading || "Institutional Audit Reports"}
            </h2>
          </div>

          <div className="audit-timeline">
            {reports.map((item, index) => {
              // Prefer the explicit year; fall back to stripping the title prefix.
              const yearText = item.year || (item.title || '').replace('Audit Reports ', '');

              return (
                <div key={index} className="audit-timeline-item">
                  <div className="audit-timeline-node"></div>

                  <div className="audit-timeline-card">
                    <div className="audit-timeline-card__glow"></div>

                    <div className="audit-timeline-card__content">
                      <div className="audit-timeline-card__left">
                        <span className="audit-timeline-card__badge">Financial Year</span>
                        <h3 className="audit-timeline-card__year">{yearText}</h3>
                      </div>

                      <div className="audit-timeline-card__right">
                        <a href={mediaUrl(item.pdf)} target="_blank" rel="noopener noreferrer" className="audit-timeline-btn">
                          <FaFilePdf className="audit-timeline-btn__icon" />
                          View PDF
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>

      <Footer />
    </>
  );
};

export default AuditReports;
